import catalogJson from '../../backend/src/extranpcs_studio/contracts/paper-1.21.8-items.json'

type PaperItemCatalog = {
  schemaVersion: number
  minecraftVersion: string
  paperApi: string
  source: string
  items: string[]
}

const catalog = catalogJson as PaperItemCatalog
if (catalog.schemaVersion !== 1 || catalog.minecraftVersion !== '1.21.8'
  || catalog.paperApi !== '1.21.8-R0.1-SNAPSHOT') {
  throw new Error('Studio Paper item catalog metadata is incompatible')
}
const sortedUniqueItems = [...new Set(catalog.items)].sort()
if (catalog.items.length === 0 || catalog.items.includes('minecraft:air')
  || catalog.items.some(item => !item.startsWith('minecraft:'))
  || catalog.items.some((item, index) => item !== sortedUniqueItems[index])) {
  throw new Error('Studio Paper item catalog is malformed or non-deterministic')
}

export const PAPER_MINECRAFT_VERSION = catalog.minecraftVersion
export const PAPER_ITEM_IDS = Object.freeze([...catalog.items])
const paperItemIdSet = new Set(PAPER_ITEM_IDS)

export function normalizePaperItemId(value: string | null | undefined): string | null {
  if (!value) return null
  const raw = value.trim().toLowerCase()
  const canonical = raw.includes(':') ? raw : `minecraft:${raw}`
  return paperItemIdSet.has(canonical) ? canonical : null
}

export function paperItemLabel(value: string): string {
  const path = value.replace(/^minecraft:/, '')
  return path.split('_').map((part) => part ? part[0].toUpperCase() + part.slice(1) : part).join(' ')
}
